import script from "./DetalhesParceriaView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesParceriaView.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesParceriaView.vue?vue&type=style&index=0&id=7e1a1388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1a1388"]])

export default __exports__